import { CheckboxTableRow, ExTable, TableBody, TableHead, useMultipleCheckForm } from 'components/shared/widget'
import { Probe, ProbeSearchForm } from 'entities/probe'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { probeColumnInfoList, ProbeTableData } from 'components/probe/probe_table'
import { useFetchProbesApi } from 'api/probe'
import BaseSelectModal from 'components/shared/base_select_modal'
import { useForm } from 'utils/hooks'
import { CSSProperties } from 'styled-components'

type SelectProbeModalProps = {
    defaultSearchForm?: ProbeSearchForm
    openButtonText: string
    executeButtonText: string
    onClick: (probes: Probe[]) => void
    onChange?: (probes: Probe[]) => void
    dropdown?: boolean
    circle?: boolean
    variant?: string
    hiddenSearchParams?: string[]
    onOpen?: () => void
    disableList?: number[]
    initialItems?: Probe[]
    openButtonStyle?: CSSProperties
}

const SelectProbeModal = (props: SelectProbeModalProps) => {
    const searchForm = useForm<ProbeSearchForm>(props.defaultSearchForm ? props.defaultSearchForm : {})
    const api = useFetchProbesApi(searchForm)
    const patientDisplaySetting = useDisplaySetting(probeColumnInfoList(searchForm), 'SelectPatient', 'default_visible', [], true)
    const multipleCheckForm = useMultipleCheckForm<Probe>(props.initialItems)

    return (
        <BaseSelectModal
            title="Probe選択"
            multipleCheckForm={multipleCheckForm}
            searchForm={searchForm}
            pageSet={api.pageSet}
            pagingResponse={api.response}
            {...props}
            onOpen={() => {
                if (props.onOpen) {
                    props.onOpen()
                }
                multipleCheckForm.reset()
                api.execute()
            }}
        >
            <div>
                <ExTable className="sticky-table">
                    <TableHead>
                        <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} disableList={props.disableList}>
                            <TableHeads displaySetting={patientDisplaySetting} />
                        </CheckboxTableRow>
                    </TableHead>
                    <TableBody loading={api.loading}>
                        {api.response.results.map((probe: Probe) => {
                            return (
                                <CheckboxTableRow
                                    key={`clinical-${probe.id}`}
                                    item={probe}
                                    multipleCheckForm={multipleCheckForm}
                                    disableList={props.disableList}
                                >
                                    <ProbeTableData probe={probe} displaySetting={patientDisplaySetting} />
                                </CheckboxTableRow>
                            )
                        })}
                    </TableBody>
                </ExTable>
            </div>
        </BaseSelectModal>
    )
}

export default SelectProbeModal
